import { Box, Flex, Spinner, SimpleGrid } from "@chakra-ui/react";
import { TrendingTitle } from "./style";
import { useTranslation } from "react-i18next";
import CertificateCard from "./CertificateCard";
import { MyLearningService } from "@root/services/my-learning";
import { useEffect, useState } from "react";
import ViewAllToggle from "../common/ViewAllToggle";
import { useNavigate } from "react-router-dom";
import { ROUTE_NAMES, CERTIFICATES_TAB_INDEX } from "@root/constants";

const myLearningService = new MyLearningService();

const AvailableCertificates = () => {
  const { t } = useTranslation("common");
  const navigate = useNavigate();
  const [certificateData, setCertificateData] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const fetchCompletedCertificates = async () => {
      setLoading(true);
      try {
        const res = await myLearningService.fetchMyLearning({
          status: "completed",
          offset: 0,
          limit: 4,
        });
        setCertificateData(res?.data?.data);
      } catch (error) {
        console.warn(error);
      } finally {
        setLoading(false);
      }
    };
    fetchCompletedCertificates();
  }, []);

  const rows = certificateData?.rows || [];
  const totalCount = certificateData?.count || rows?.length || 0;
  const showToggle = totalCount > 4;
  const visibleRows = expanded ? rows : rows?.slice(0, 4);

  const handleToggle = () => {
    if (!expanded) {
      navigate(ROUTE_NAMES.JOURNALIST_LEARNING, {
        state: { activeTabIndex: CERTIFICATES_TAB_INDEX },
      });
    } else {
      setExpanded(false);
    }
  };

  const formatDate = (dateString: string) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}.${month}.${day}`;
  };

  const renderCertificateCard = (journalist: any) => (
    <CertificateCard
      key={journalist?.id}
      id={journalist?.course?.id}
      courseTitle={journalist?.course?.title}
      completionDate={`${formatDate(journalist?.startedAt)} - ${formatDate(
        journalist?.completedAt
      )}`}
      organizatinoName={journalist?.subscriber?.fullName}
      journalistName={journalist?.organizationMembership?.fullName}
    />
  );

  const renderAvailableCertificates = () => {
    if (loading) {
      return (
        <Flex justify="center" align="center" minHeight="200px">
          <Spinner size="lg" />
        </Flex>
      );
    }

    if (totalCount === 0) return null;

    return (
      <SimpleGrid columns={{ base: 1, sm: 2, md: 3, lg: 4 }} spacing={3}>
        {visibleRows?.map((journalist: any) =>
          renderCertificateCard(journalist)
        )}
      </SimpleGrid>
    );
  };

  return (
    <Box
      data-tour-item="journalist-certificates"
      width="100%"
      display="flex"
      flexDirection="column"
      gap={4}
    >
      <Flex align="center" justify="space-between">
        <TrendingTitle>
          {t("kpecDashboard.availableCertificates")}
        </TrendingTitle>
        <ViewAllToggle
          expanded={expanded}
          onToggle={handleToggle}
          showToggle={showToggle}
        />
      </Flex>

      {renderAvailableCertificates()}
    </Box>
  );
};

export default AvailableCertificates;
